export class Installation {
  constructor(
    public reference: string | null,
    public id: string | null | string[],
    public device: Device | any,
    public gateway: Gateway | any
  ) {}
}

export class Device {
  constructor(public id: string | null, public macAddress: string | null) {}
}

export class Gateway {
  constructor(
    public reference: string | null,
    public id: string | null,
    public serialNumber: string | null
  ) {}
}

export class ParkScheduleLog {
  constructor(
    public requestId: string,
    public createdBy: string,
    public createdAt: string,
    public updatedAt: string,
    public scheduleSlot: number,
    public channel: number,
    public switchOnTime: string,
    public switchOffTime: string,
    public dimming: number,
    public status: string,
    public totalInstallations: number,
    public successCount: number,
    public failCount: number
  ) {}
}

export class ParkCommandLog {
  constructor(
    public requestId: string,
    public installationId: string,
    public macAddress: string,
    public serialNumber: string,
    public cmdIndex: number,
    public command: any,
    public status: string,
    public createdAt: string
  ) {}
}

export class PaginationInfo {
  constructor(
    public count: number,
    public total: number,
    public hasNextPage: boolean,
    public hasPreviousPage: boolean,
    public startCursor: string | null,
    public endCursor: string | null
  ) {}
}
